import PlaceDate from '@/utils/placeDate';
import VueI18n from 'vue-i18n';
import i18n from '@/translations/i18n';
import SystemDate from '@/utils/systemDate';

export const ONE_DAY_IN_MILLISECONDS = 86400000;
export const ONE_MINUTE_IN_SECONDS = 60;
export const ONE_HOUR_IN_SECONDS = 3600;
export const ONE_SECOND_IN_MILLISECONDS: number = 1000;
export const ONE_DAY_IN_SECONDS = 86400;
export const ONE_WEEK_IN_SECONDS = 604800;

export default {
  getHumanDateString(date: SystemDate | PlaceDate, todayTimestamp: number): string | VueI18n.TranslateResult {
    const yesterday: number = todayTimestamp - ONE_DAY_IN_MILLISECONDS;
    const tomorrow: number = todayTimestamp + ONE_DAY_IN_MILLISECONDS;
    const afterTomorrow = tomorrow + ONE_DAY_IN_MILLISECONDS;
    const afterAfterTomorrow = afterTomorrow + ONE_DAY_IN_MILLISECONDS;
    const dateTS: number = date.getTime();

    if (yesterday <= dateTS && dateTS < todayTimestamp) {
      return i18n.t('global.entity.yesterday');
    } else if (todayTimestamp <= dateTS && dateTS < tomorrow) {
      return i18n.t('global.entity.today');
    } else if (tomorrow <= dateTS && dateTS < afterTomorrow) {
      return i18n.t('global.entity.tomorrow');
    } else if (afterTomorrow <= dateTS && dateTS < afterAfterTomorrow) {
      return i18n.t('global.entity.day_after_tomorrow');
    }

    return `${date.getDate()} ${this.getHumanMonthByDate(date)}`;
  },
  getHumanMonthByDate(date: Date): string | VueI18n.TranslateResult {
    return i18n.t(`global.month.${date.getMonth() + 1}.full`);
  },
  getHumanMonthThByDate(date: Date): string | VueI18n.TranslateResult {
    return i18n.t(`global.month.${date.getMonth() + 1}.th`);
  },
  getHumanFullWeekByDate(date: SystemDate): string | VueI18n.TranslateResult {
    return i18n.t(`global.week.${date.getEuropeanDay()}.full`);
  },
  getHumanShortWeekByDate(date: SystemDate): string | VueI18n.TranslateResult {
    return i18n.t(`global.week.${date.getEuropeanDay()}.short`);
  }
};
